module.exports = __webpack_public_path__ + "static/img/tianheng.5b34083.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tianheng/tianheng.png
// module id = yAp5
// module chunks = 0